import { render, staticRenderFns } from "./FileUploadSection.vue?vue&type=template&id=88d1b4a2&scoped=true"
import script from "./FileUploadSection.vue?vue&type=script&lang=js"
export * from "./FileUploadSection.vue?vue&type=script&lang=js"
import style0 from "./FileUploadSection.vue?vue&type=style&index=0&id=88d1b4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1b4a2",
  null
  
)

export default component.exports